export const sessiontypeData = [
    { name: "Modbus RTU", id: 3 },
    { name: "LoRaWAN", id: 5 },
    { name: "BacNet IP", id: 6 },
    { name: "Modbus IP", id: 7 },
    { name: "Wavenis", id: 4 },
    { name: "S7Profinet", id: 8 },
    { name: "Modbus IP V2", id: 9 },
    { name: "Mitsubishi XML", id: 10 },
]